import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Typography, Box, ButtonGroup, Button } from "@mui/material";

const SalesChart = () => {
  const [timeRange, setTimeRange] = useState("monthly");

  // Sample data - replace with actual data from your API
  const monthlyData = {
    series: [
      {
        name: "Sales",
        data: [
          31000, 40000, 28000, 51000, 42000, 82000, 56000, 47000, 62000, 51000,
          42000, 37000,
        ],
      },
    ],
    categories: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  };

  const weeklyData = {
    series: [
      {
        name: "Sales",
        data: [11000, 15000, 12000, 21000, 19000, 17000, 14000],
      },
    ],
    categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  };

  const data = timeRange === "monthly" ? monthlyData : weeklyData;

  const options = {
    chart: {
      height: 300,
      type: "area",
      toolbar: {
        show: false,
      },
      fontFamily: "Outfit, sans-serif",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2.5,
      colors: ["#5652B0"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.35,
        opacityTo: 0.05,
        stops: [0, 90, 100],
        colors: ["#5652B0"],
      },
    },
    xaxis: {
      categories: data.categories,
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "11px",
          fontFamily: "Outfit, sans-serif",
          fontWeight: 400,
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return "₹" + val.toLocaleString("en-IN");
        },
        style: {
          colors: "#6B7280",
          fontSize: "11px",
          fontFamily: "Outfit, sans-serif",
          fontWeight: 400,
        },
      },
    },
    grid: {
      borderColor: "#F3F4F6",
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
      style: {
        fontSize: "12px",
        fontFamily: "Outfit, sans-serif",
      },
    },
    colors: ["#5652B0"],
  };

  return (
    <Box className="p-5">
      <Box className="flex justify-between items-center mb-4">
        <Typography variant="subtitle1" className="font-medium text-[#374151]">
          Sales Overview
        </Typography>
        <ButtonGroup
          variant="outlined"
          size="small"
          sx={{
            ".MuiButtonGroup-grouped": {
              borderColor: "rgba(86, 82, 176, 0.15)",
            },
          }}>
          <Button
            onClick={() => setTimeRange("weekly")}
            sx={{
              fontSize: "0.7rem",
              textTransform: "none",
              padding: "3px 8px",
              minWidth: "60px",
              color: timeRange === "weekly" ? "white" : "#5652B0",
              backgroundColor:
                timeRange === "weekly" ? "#5652B0" : "transparent",
              borderColor: "rgba(86, 82, 176, 0.15)",
              "&:hover": {
                backgroundColor:
                  timeRange === "weekly"
                    ? "#4A47A3"
                    : "rgba(86, 82, 176, 0.05)",
                borderColor: "rgba(86, 82, 176, 0.2)",
              },
            }}>
            Weekly
          </Button>
          <Button
            onClick={() => setTimeRange("monthly")}
            sx={{
              fontSize: "0.7rem",
              textTransform: "none",
              padding: "3px 8px",
              minWidth: "60px",
              color: timeRange === "monthly" ? "white" : "#5652B0",
              backgroundColor:
                timeRange === "monthly" ? "#5652B0" : "transparent",
              borderColor: "rgba(86, 82, 176, 0.15)",
              "&:hover": {
                backgroundColor:
                  timeRange === "monthly"
                    ? "#4A47A3"
                    : "rgba(86, 82, 176, 0.05)",
                borderColor: "rgba(86, 82, 176, 0.2)",
              },
            }}>
            Monthly
          </Button>
        </ButtonGroup>
      </Box>
      <Box sx={{ height: 270 }}>
        <ReactApexChart
          options={options}
          series={data.series}
          type="area"
          height="100%"
        />
      </Box>
    </Box>
  );
};

export default SalesChart;
